import React from "react";
import { useParams } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import {
  ShortcutUpsertContextProps,
  TtzkPortalShortcutUpsertService,
} from "../../../../application/service/ttzk-portal/ttzk-portal-upsert-service";

import ShortcutForm from "../../../organisms/ttzk-portal/shortcut-form";
import { PortalTemplate } from "../../../template/portal/default-template";
import { TtzkPortalR } from "../route";

const ShortcutEdit: React.FC<ShortcutUpsertContextProps> = ({
  fetchShortcutById,
  shortcut,
  onSave,
  onChange,
  onFileAttached,
  setOrganization,
  isUpdating,
}) => {
  const { shortcutId } = useParams<{ shortcutId: string }>();

  React.useEffect(() => {
    fetchShortcutById(shortcutId);
  }, [fetchShortcutById, shortcutId]);

  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: TtzkPortalR.ShortcutList.link({}), title: "ショートカット一覧" },
        {
          to: TtzkPortalR.ShortcutDetail.link({ shortcutId }),
          title: shortcut.name,
        },
      ]}
    >
      <ShortcutForm
        onChange={onChange}
        onSave={onSave}
        shortcut={shortcut}
        onFileAttached={onFileAttached}
        setOrganization={setOrganization}
        isUpdating={isUpdating}
      />
    </PortalTemplate>
  );
};

export const ShortcutEditContainer = connectPageService(
  ShortcutEdit,
  () => new TtzkPortalShortcutUpsertService(),
);
